import HeaderInternal from "./parts/header-internal";
import Footer from "./parts/footer";

function Privacy() {
    return (
    <>
        <HeaderInternal />
        <div className="container w-full max-w-screen-sm m-auto my-16">
            <article>
                <h1>Політика Приватності</h1>
                <p>Ця Політика приватності (надалі – «Політика») застосовується до усіх питань обробки та захисту
                    Персональних даних Користувачів сайту https://hrws.delo.ua/ (надалі – «Сайт»).</p>
                <p>Використовуючи Сайт, Користувач погоджується з усіма правилами та умовами Політики. Користувач
                    зобов’язаний ознайомлюватися з Політикою перед початком використання Сайту і у разі незгоди
                    (повністю або частково) з її правилами та умовами припинити використання Сайту.</p>
                <p>Ми залишаємо за собою право вносити зміни в цю Політику. Ми інформуємо Користувачів про зміни
                    шляхом зміни дати публікації.</p>
                <h2>ОСНОВНІ ПОНЯТТЯ (ТЕРМІНИ)</h2>
                <p>Персональні дані – це будь-яка інформація персонального характеру, яка дозволяє ідентифікувати
                    фізичну особу (суб’єкта даних).</p>
                <p>Суб’єкт Персональних даних – це фізична особа, якої стосуються Персональні дані і яку можна
                    ідентифікувати або яка вже ідентифікована за цими Персональними даними. Суб’єктами Персональних
                    даних у розумінні цієї Політики є Користувачі</p>
                <p>Володілець Персональних даних — фізична або юридична особа, яка визначає мету обробки
                    Персональних даних, встановлює склад цих даних та процедури їх обробки. Володільцем Персональних
                    даних у розумінні цієї Політики є Адміністрація Сайту (далі – «Ми», «Адміністрація»).</p>
                <p>Обробка Персональних даних Користувачів здійснюється відповідно до вимог Закону України «Про
                    захист Персональних даних».</p>
                <h2>ЦІЛІ ОБРОБКИ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
                <p>Персональні дані потрібні нам для того, щоб ми могли, зокрема, але не виключно: повноцінно
                    надавати весь спектр Послуг; ідентифікувати зареєстрованого Користувача; вести комунікацію з
                    Користувачем у процесі надання Послуг, зокрема, робити важливі повідомлення про умови послуг,
                    налаштовувати нагадування; покращувати якість Послуг та персоналізовувати їх для Користувачів;
                    розглядати звернення та запити Користувачів; здійснювати статистичні, дослідження на основі
                    анонімізованих даних.</p>
                <h2>ПРАВОВІ ПІДСТАВИ ДЛЯ ОБРОБКИ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
                <p>Ми обробляємо Персональні дані тільки, якщо наявна принаймні одна з наступних законних підстав:
                    обробка є необхідною для надання Послуг відповідно до Оферти; надали згоду на обробку
                    Персональних даних; обробка є необхідною для задоволення вимог законодавства або у нас є
                    законний інтерес на таку обробку.</p>
                <h2>ПЕРСОНАЛЬНІ ДАНІ, ЯКІ МИ ОБРОБЛЯЄМО</h2>
                <p>Під час будь-якого використання Сайту незалежно від реєстрації ми автоматично збираємо такі дані:
                    IP-адреса; сookie файли; назва домену чи URL, з якого Користувач заходить на Сайт; тип браузера;
                    дата і час відвідування Сайту.</p>
                <p>Відповідно до цілей, ми можемо збирати такі категорії персональних даних: прізвище, ім’я, номер
                    телефону, email, промокод, контактні дані посадової особи (для корпоративних клієнтів),
                    банківські дані, адресу, посилання на аккаунт у соціальних мережах тощо.</p>
                <h2>УМОВИ ЗБОРУ ТА ОБРОБКИ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
                <p>Ми не можемо перевірити правильність та точність наданих Користувачем даних, а тому Адміністрація
                    презюмує, що Користувач є повнолітнім та не має обмежень, пов’язаних з його дієздатністю, а
                    також вказує достовірну інформацію про себе в обсягах, необхідних для надання Послуг.</p>
                <h2>МІСЦЕ ЗБЕРІГАННЯ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
                <p>Ми зберігаємо ваші персональні дані в Україні.</p>
                <h2>ПЕРЕДАЧА ПЕРСОНАЛЬНИХ ДАНИХ ТРЕТІМ ОСОБАМ</h2>
                <p>За загальним правилом ми не передаємо персональні дані Користувачів третім особам. Для надання
                    послуг Користувачам, ми можемо передавати їх підрядникам, які виступають Розпорядниками
                    персональних даних, за умови виконання вимог описаних у розділі ТЕХНІЧНІ, ОРГАНІЗАЦІЙНІ ТА ІНШІ
                    ЗАХОДИ ЗАХИСТУ ПЕРСОНАЛЬНИХ ДАНИХ. Персональні дані Користувачів можуть також передаватися
                    судовим та правоохоронним органам за їх обґрунтованим зверненням. У будь-якому випадку ми
                    приймаємо рішення про таку передачу із врахуванням можливих ризиків для законних прав та
                    інтересів Користувачів.</p>
                <h2>ТЕХНІЧНІ, ОРГАНІЗАЦІЙНІ ТА ІНШІ ЗАХОДИ ЗАХИСТУ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
                <p>З метою безпечного зберігання Персональних даних ми впровадили технічні і організаційні засоби,
                    які захищають Персональні дані від неавторизованої або незаконної обробки та від ненавмисної
                    втрати, знищення або пошкодження, серед іншого: контроль та обмеження доступу до Персональних
                    даних; обмеження зберігання Персональних даних.</p>
                <h2>ЧАС ЗБЕРІГАННЯ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
                <p>Ми гарантуємо, що зберігатимемо Персональні дані протягом того періоду, що є необхідним для
                    досягнення цілей обробки таких даних або дотримання встановлених законом вимог. Конкретний
                    період зберігання Персональних даних ми встановлюємо залежно від категорії таких даних, цілей
                    їхньої обробки і можливості досягти ці цілі за допомогою інших засобів.</p>
                <h2>ПРАВА СУБ’ЄКТІВ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
                <p>Користувачі як суб’єкти персональних даних мають наступні права:</p>
                <ul>
                    <li>знати про джерела збирання, місцезнаходження своїх Персональних даних, мету їх обробки,
                        місцезнаходження або місце проживання (перебування) володільця чи розпорядника Персональних
                        даних або дати відповідне доручення щодо отримання цієї інформації уповноваженим ним особам,
                        крім випадків, встановлених законом; отримувати інформацію про умови надання доступу до
                        Персональних даних, зокрема інформацію про третіх осіб, яким передаються його Персональні
                        дані;
                    </li>
                    <li>на доступ до своїх Персональних даних;</li>
                    <li>пред’являти вмотивовану вимогу володільцю Персональних даних із запереченням проти обробки
                        своїх Персональних даних;
                    </li>
                    <li>пред'являти вмотивовану вимогу щодо зміни або знищення своїх Персональних даних будь-яким
                        володільцем та розпорядником Персональних даних, якщо ці дані обробляються незаконно чи є
                        недостовірними;
                    </li>
                    <li>на захист своїх Персональних даних від незаконної обробки;</li>
                    <li>звертатися із скаргами на обробку своїх Персональних даних до Уповноваженого Верховної Ради
                        України з прав людини або до суду;
                    </li>
                    <li>застосовувати засоби правового захисту в разі порушення законодавства про захист
                        Персональних даних;
                    </li>
                    <li>вносити застереження стосовно обмеження права на обробку своїх Персональних даних під час
                        надання згоди;
                    </li>
                    <li>відкликати згоду на обробку Персональних даних;</li>
                    <li>знати механізм автоматичної обробки Персональних даних;</li>
                    <li>на захист від автоматизованого рішення, яке має для нього правові наслідки.</li>
                </ul>
            </article>
        </div>
        <Footer />
    </>
    )
}

export default Privacy;